export default function isFreePlan(plan) {
  return plan.toLowerCase().includes('starter');
}
